import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import { createStatus, bulkUpload, bulkResults } from "../../reducers/users";

const BulkUserModal = (props) => {
  const dispatch = useDispatch();
  const createSubmitStatus = useSelector(createStatus);
  const bulkResultsArr = useSelector(bulkResults);
  const [ selectedFile, setSelectedFile ] = useState(false);
  const hiddenFileInput = useRef(null);
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;

  const modalClose = () => {
    props.closeModal(false);
  }
  
  const handleClick = event => {
    hiddenFileInput.current.click();
  };

  useEffect(() => {
     if(createSubmitStatus === 'succeeded') {
        props.closeModal(false);
     }
  }, [createSubmitStatus,props]);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = (event) => {
    event.preventDefault();
    dispatch(bulkUpload(selectedFile));
  };

  return (
    <Modal show={props.show} onHide={modalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Bulk User Upload<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <h2>Instructions</h2>
        <ul>
            <li>Download <a href={apiUrl + '/img/user_template.csv'}>this</a> template</li>
            <li>Fill in all the information for each user.  All fields are required.</li>
            <li>Save the file as a csv file</li>
            <li>Click the Choose File button below to select the users file</li>
            <li>Click the Upload button below to process the users</li>
            <li>Users will be asked to complete their profile when they login for the first time</li>
        </ul>
        <form className="App" onSubmit={handleUpload}>
            <Button onClick={handleClick}>
                Choose File
            </Button>
            <br/>
            <br/>
            Selected File: {selectedFile.name} <br />
            <input type="file" name="file" onChange={handleFileChange} ref={hiddenFileInput}
                style={{display:'none'}} />
            <br/>
            <Button onClick={handleUpload}>Upload</Button>
        </form>
        <br/>
        <h2>Upload Results</h2>
            <ul>
        { bulkResultsArr && bulkResultsArr.map(error => (
            <li>{error.username} - {error.error}</li>
          ))
        }
        </ul>
    </Modal.Body>
    </Modal>
  );
};

export default BulkUserModal; 